import { useState, createContext } from "react";

export const SiteContext = createContext();

const SiteContextProvider = ({ children }) => {
    const [site, setSite] = useState({});

    const clearSite = () => {
        setSite({});
    };

    const values = {
        site,
        setSite,
        clearSite,
    };
    return <SiteContext.Provider value={values}>{children}</SiteContext.Provider>;
};

export default SiteContextProvider;
